<template>
	<v-container fill-height fluid grid-list-xl>
		<v-layout justify-center wrap>
			<v-flex xs12 md8>
				<UserForm class="user-info-form" :user="user" @userUpdated="fetchUser"/>
			</v-flex>
			<v-flex xs12 md4>
        <UserAvatar v-if="userReady" :user="user" :authenticateduser="currentAuthenticatedUser"/>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>

  import UserForm from "./userForm/userForm";
  import UserAvatar from "./userAvatar/userAvatar";
	import { GetUserByEmail } from "@/services/API.js";
	import Auth from "@/services/Auth";

	export default {
		name: 'Account',
    components: {
      UserForm,
      UserAvatar
    },
		data () {
			return {
				user: {},
				currentAuthenticatedUser: {},
				userReady: false
			}
		},
		beforeMount() {
			this.fetchUser();
		},
		methods: {
			async fetchUser() {
				this.user = await Auth.currentSession();
				this.currentAuthenticatedUser = this.user.User;
				
				const res = await GetUserByEmail(this.currentAuthenticatedUser.email);

				if (res) {
					this.user = res;
					this.userReady = true;
				}
			}
		}
  }
</script>

<style lang="scss">
  // Adds texture/border to container
  .outline {
    padding: 10px;
    box-shadow: 3px 1px 7px 3px #0000001f;
  }
</style>
